var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj, AsyncRequestStatus, someRequestIsPending } from "@ane/core/lib/models";
import MetricServiceResource, { AnalysisTemplateTypeDto } from "@ane/exp-data/lib/resources/MetricServiceResource";
import { g as getAnalysisTemplateV2DtoFromXML, s as segmentDictionaryKey, a as getPrimarySegmentsV2, b as getSecondarySegmentsV2, p as parseTriggerFilterCondition, c as parseSideStreamInfo, J as JoinColumnPairDefaults } from "../../../../../../AnalysisFormUtils-724038a8.js";
import { SupportFileType } from "../SupportFilesTab/SupportFilesForm.utils.js";
import { getForayAppCustomParametersV2 } from "../ForayAppSettings/ForayAppSetting.utils.js";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import AnalysisResources from "../../../module/AnalysisResources.js";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import ___default from "lodash";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { convertToRawStudy } from "../../../utils/ContractConverterUtils.js";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ANALYSIS_CREATE_QUERY } from "@ane/core/lib/constants/QueryString.constants";
const defaultReducerState = {
  stepId: "",
  managementGroup: "",
  workspaceId: "",
  studyDataAsync: getDefaultAsyncWrapperObj(),
  experimentStepMetadataAsync: getDefaultAsyncWrapperObj(),
  jobExecutionMetadataAsync: getDefaultAsyncWrapperObj(),
  analysisConfigAsync: getDefaultAsyncWrapperObj(),
  analysisRequestFormResultAsync: getDefaultAsyncWrapperObj(),
  metricSetsResultAsync: getDefaultAsyncWrapperObj(),
  forayConfigMetadata: getDefaultAsyncWrapperObj(),
  metricSetVersionDictAsync: {},
  analysisCreateRequest: {},
  templateNameV2DictAsync: {},
  templateFromVersionDictAsync: {},
  templateNamesFromVersionDictAsync: {},
  segmentsDictAsync: {},
  createdAnalysisStudyId: getDefaultAsyncWrapperObj(),
  scopeReferencesSupportedFiles: {},
  scopeResourcesSupportedFiles: {},
  sampleForayJobConfigResultAsync: getDefaultAsyncWrapperObj(),
  forayValidationResponseAsync: getDefaultAsyncWrapperObj(),
  subscribers: []
};
const prefix = "AnalysisCreate";
const createActionTypes = (actionPrefix) => {
  return {
    LOAD: `${prefix}/${actionPrefix}/LOAD`,
    LOADING: `${prefix}/${actionPrefix}/LOADING`,
    LOADED: `${prefix}/${actionPrefix}/LOADED`
  };
};
const loadAnalysisSegmentsActionTypes = createActionTypes("SegmentData");
const createAnalysisStudyActionTypes = createActionTypes("createAnalysisStudy");
const afterCreateAnalysisStudyActionTypes = `${prefix}/afterCreateAnalysisStudy`;
const uploadSupportFilesActionTypes = createActionTypes("uploadSupportFiles");
const sampleForayJobConfigActionTypes = createActionTypes("sampleForayJobConfig");
const validateForayJobConfigActionTypes = createActionTypes("validateForayConfig");
const storeStepIdAndMgActionType = `${prefix}/storeStepIdAndManagementGroup`;
const storeStepIdAndManagementGroup = (stepId, managementGroup, workspaceId) => {
  return {
    type: storeStepIdAndMgActionType,
    payload: {
      stepId,
      managementGroup,
      workspaceId
    }
  };
};
const loadAnalysisStepPropertiesEpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisStepProperties`,
  reduxKeyNested: () => ["experimentStepMetadataAsync"],
  loadResource: (inputPayload) => AnalysisResources.getAnalysisStepProperties(inputPayload.stepId),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    var _a;
    return initialLoadResource(
      inputPayload,
      outputPayload.ExpManagementGroup,
      outputPayload.WorkspaceId,
      (_a = NavigationService.getQueryParamValue(ANALYSIS_CREATE_QUERY.METRIC_SET_NAME)) != null ? _a : void 0
    );
  }
};
const loadAnalysisStepPropertiesEpicReducer = loadResourcesUtils(loadAnalysisStepPropertiesEpicReducerArg);
const loadRawStudyEpicReducerArg = {
  actionPrefix: `${prefix}/loadRawStudy`,
  reduxKeyNested: () => ["studyDataAsync"],
  loadResource: (inputPayload, state) => AnalysisResourceV2.getAnalysis(inputPayload.workspaceId, parseInt(inputPayload.studyId)),
  onCompleteSuccess: (resourceResult, inputPayload) => {
    var _a, _b;
    const analysis = resourceResult.value;
    inputPayload.isOneOff = (_b = (_a = analysis == null ? void 0 : analysis.analysisTemplate) == null ? void 0 : _a.analysisTemplateOverrides) == null ? void 0 : _b.isOneOff;
    return convertToRawStudy(resourceResult.value);
  },
  afterActionsOnSuccess: (inputPayload, outputPayload) => [],
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.studyDataAsync);
  }
};
const loadRawStudyEpicReducer = loadResourcesUtils(loadRawStudyEpicReducerArg);
const loadForayConfigMetadataEpicReducerArg = {
  actionPrefix: `${prefix}/loadForayConfigMetadata`,
  reduxKeyNested: () => ["forayConfigMetadata"],
  loadResource: (inputPayload, state) => AnalysisResources.getForayConfigMetadata(),
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.forayConfigMetadata);
  }
};
const loadForayConfigMetadataEpicReducer = loadResourcesUtils(loadForayConfigMetadataEpicReducerArg);
const loadAnalysisConfigEpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisConfig`,
  reduxKeyNested: () => ["analysisConfigAsync"],
  loadResource: (inputPayload, state) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(inputPayload.workspaceId, inputPayload.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
      workspaceId: inputPayload.workspaceId || "",
      experimentationGroup,
      section: MasterDataConstants.analysisConfigSection
    });
  },
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.analysisConfigAsync);
  }
};
const loadAnalysisConfigEpicReducer = loadResourcesUtils(loadAnalysisConfigEpicReducerArg);
const loadJobExecMetaEpicReducerArg = {
  actionPrefix: `${prefix}/loadJobExecMeta`,
  reduxKeyNested: () => ["jobExecutionMetadataAsync"],
  loadResource: (inputPayload, state) => {
    const experimentationGroup = getExperimentationGroupIdFromPath(inputPayload.workspaceId, inputPayload.managementGroup);
    return MdsDataplaneResources.getConfigWithTypeV2({
      workspaceId: inputPayload.workspaceId,
      experimentationGroup,
      section: MasterDataConstants.jobExecutionMetadataSection
    });
  },
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.jobExecutionMetadataAsync);
  }
};
const loadJobExecMetaEpicReducer = loadResourcesUtils(loadJobExecMetaEpicReducerArg);
const loadAnalysisRequestFormEpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisRequestForm`,
  reduxKeyNested: () => ["analysisRequestFormResultAsync"],
  loadResource: (inputPayload, state) => AnalysisResources.getAnalysisRequestForm(inputPayload.stepId, inputPayload.isStudio),
  onCompleteSuccess: (resourceResult) => resourceResult,
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.analysisRequestFormResultAsync);
  }
};
const loadAnalysisRequestFormEpicReducer = loadResourcesUtils(loadAnalysisRequestFormEpicReducerArg);
const loadMetricSetsEpicReducerArg = {
  actionPrefix: `${prefix}/loadMetricSets`,
  reduxKeyNested: () => ["metricSetsResultAsync"],
  loadResource: (inputPayload) => MetricServiceResource.getMetricSets({ workspaceId: inputPayload.workspaceId }),
  onCompleteSuccess: (resourceResult) => resourceResult,
  dontLoad: (inputPayload, state) => {
    var _a;
    return dontLoad((_a = state == null ? void 0 : state.analysisCreate) == null ? void 0 : _a.metricSetsResultAsync);
  }
};
const loadMetricSetsEpicReducer = loadResourcesUtils(loadMetricSetsEpicReducerArg);
const loadMetricSetVersionEpicReducerArg = {
  actionPrefix: `${prefix}/loadMetricSetVersion`,
  reduxKeyNested: (inputPayload) => ["metricSetVersionDictAsync", inputPayload.metricSetName],
  loadResource: (inputPayload) => MetricServiceResource.getMetricVersionsByMetricSetName(inputPayload.metricSetName || "", inputPayload.workspaceId || ""),
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadMetricSetVersionEpicReducer = loadResourcesUtils(loadMetricSetVersionEpicReducerArg);
const loadMetricSetVersion = loadMetricSetVersionEpicReducer.actionCreators.load;
const loadSegmentData = (loadSegmentActionData) => {
  return {
    type: loadAnalysisSegmentsActionTypes.LOAD,
    payload: __spreadValues({}, loadSegmentActionData)
  };
};
const loadingSegmentData = (loadSegmentActionData) => {
  return {
    type: loadAnalysisSegmentsActionTypes.LOADING,
    payload: __spreadValues({}, loadSegmentActionData)
  };
};
const loadedSegmentData = (loadSegmentActionData, segmentDataAsync) => {
  return {
    type: loadAnalysisSegmentsActionTypes.LOADED,
    payload: __spreadProps(__spreadValues({}, loadSegmentActionData), {
      segmentDataAsync
    })
  };
};
const loadAnalysisTemplateV2EpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisTemplateV2`,
  reduxKeyNested: (inputPayload) => ["templateNameV2DictAsync", inputPayload.templateName],
  loadResource: (inputPayload) => {
    return inputPayload.isMetricServiceTemplate ? MetricServiceResource.getAnalysisTemplate(inputPayload.workspaceId, inputPayload.templateName) : AnalysisResources.readTemplate(inputPayload.templateName);
  },
  onCompleteSuccess: (successData, inputPayload) => {
    var _a;
    return inputPayload.isMetricServiceTemplate ? ((_a = successData == null ? void 0 : successData.length) != null ? _a : 0) > 0 ? successData[0] : void 0 : getAnalysisTemplateV2DtoFromXML(successData);
  },
  afterActionsOnSuccess: (inputPayload, outputPayload) => postAnalysisTemplateV2LoadResource(inputPayload, outputPayload)
};
const loadAnalysisTemplateV2EpicReducer = loadResourcesUtils(loadAnalysisTemplateV2EpicReducerArg);
const loadAnalysisTemplateFromVersionEpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisTemplateFromVersion`,
  reduxKeyNested: (inputPayload) => [
    "templateFromVersionDictAsync",
    inputPayload.templateName
  ],
  loadResource: (inputPayload) => {
    return MetricServiceResource.getAnalysisTemplateFromVersion(
      inputPayload.workspaceId,
      inputPayload.metricSetName,
      inputPayload.metricSetVersionName,
      inputPayload.templateName
    );
  },
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => postAnalysisTemplateFromVersionLoadResource(inputPayload, outputPayload)
};
const loadAnalysisTemplateFromVersionEpicReducer = loadResourcesUtils(loadAnalysisTemplateFromVersionEpicReducerArg);
const loadAnalysisTemplateNamesFromVersionEpicReducerArg = {
  actionPrefix: `${prefix}/loadAnalysisTemplateNamesFromVersion`,
  reduxKeyNested: (inputPayload) => [
    "templateNamesFromVersionDictAsync",
    inputPayload.metricSetVersionName
  ],
  loadResource: (inputPayload) => {
    return MetricServiceResource.getAnalysisTemplateNamesFromVersion(
      inputPayload.workspaceId,
      inputPayload.metricSetName,
      inputPayload.metricSetVersionName
    );
  },
  onCompleteSuccess: (resourceResult) => resourceResult
};
const loadAnalysisTemplateNamesFromVersionEpicReducer = loadResourcesUtils(
  loadAnalysisTemplateNamesFromVersionEpicReducerArg
);
const createAnalysisStudy = (workspaceId, analysisCreateRequest, subscribers) => {
  return {
    type: createAnalysisStudyActionTypes.LOAD,
    payload: {
      workspaceId,
      analysisCreateRequest,
      subscribers
    }
  };
};
const creatingAnalysisStudy = () => {
  return {
    type: createAnalysisStudyActionTypes.LOADING,
    payload: {}
  };
};
const createdAnalysisStudy = (createdAnalysisStudyId) => {
  return {
    type: createAnalysisStudyActionTypes.LOADED,
    payload: {
      createdAnalysisStudyId
    }
  };
};
const afterCreateAnalysisStudy = (analysisCreateRequest, studyId, subscribers, workspaceId, error) => {
  return {
    type: afterCreateAnalysisStudyActionTypes,
    payload: {
      analysisCreateRequest,
      studyId,
      subscribers,
      workspaceId,
      error
    }
  };
};
const loadSampleForayJobConfig = (analysisCreateRequest, formValues) => {
  return {
    type: sampleForayJobConfigActionTypes.LOAD,
    payload: {
      analysisCreateRequest,
      formValues
    }
  };
};
const loadingSampleForayJobConfig = () => {
  return {
    type: sampleForayJobConfigActionTypes.LOADING,
    payload: {}
  };
};
const loadedSampleForayJobConfig = (sampleForayJobConfigResult) => {
  return {
    type: sampleForayJobConfigActionTypes.LOADED,
    payload: {
      sampleForayJobConfigResultAsync: sampleForayJobConfigResult
    }
  };
};
const validateForayConfig = (forayValidationRequest) => {
  return {
    type: validateForayJobConfigActionTypes.LOAD,
    payload: {
      forayValidationRequest
    }
  };
};
const validatingForayConfig = () => {
  return {
    type: validateForayJobConfigActionTypes.LOADING,
    payload: {}
  };
};
const validatedForayConfig = (forayValidationResponseAsync) => {
  return {
    type: validateForayJobConfigActionTypes.LOADED,
    payload: {
      forayValidationResponseAsync
    }
  };
};
const uploadSupportFiles = (payload) => {
  return {
    type: uploadSupportFilesActionTypes.LOAD,
    payload: __spreadValues({}, payload)
  };
};
const uploadingSupportFiles = (supportFileType, fileStatus) => {
  return {
    type: uploadSupportFilesActionTypes.LOADING,
    payload: {
      supportFileType,
      fileStatus
    }
  };
};
const uploadedSupportFiles = (supportFileType, fileStatus) => {
  return {
    type: uploadSupportFilesActionTypes.LOADED,
    payload: {
      supportFileType,
      fileStatus
    }
  };
};
const analysisCreateReducer = (state = defaultReducerState, action) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  state = loadRawStudyEpicReducer.reduxChange(state, action);
  state = loadForayConfigMetadataEpicReducer.reduxChange(state, action);
  state = loadAnalysisStepPropertiesEpicReducer.reduxChange(state, action);
  state = loadAnalysisConfigEpicReducer.reduxChange(state, action);
  state = loadJobExecMetaEpicReducer.reduxChange(state, action);
  state = loadAnalysisRequestFormEpicReducer.reduxChange(state, action);
  state = loadMetricSetsEpicReducer.reduxChange(state, action);
  state = loadAnalysisTemplateV2EpicReducer.reduxChange(state, action);
  state = loadAnalysisTemplateFromVersionEpicReducer.reduxChange(state, action);
  state = loadAnalysisTemplateNamesFromVersionEpicReducer.reduxChange(state, action);
  state = loadMetricSetVersionEpicReducer.reduxChange(state, action);
  switch (action.type) {
    case storeStepIdAndMgActionType:
      return __spreadProps(__spreadValues({}, state), {
        stepId: action.payload.stepId || "",
        managementGroup: action.payload.managementGroup || "",
        workspaceId: action.payload.workspaceId || ""
      });
    case createAnalysisStudyActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        createdAnalysisStudyId: __spreadProps(__spreadValues({}, state.createdAnalysisStudyId), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadAnalysisSegmentsActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        segmentsDictAsync: __spreadProps(__spreadValues({}, state.segmentsDictAsync), {
          [segmentDictionaryKey(action.payload.metricSetName, action.payload.metricSetVersionSelected)]: __spreadProps(__spreadValues({}, state.segmentsDictAsync[segmentDictionaryKey(action.payload.metricSetName, action.payload.metricSetVersionSelected)]), {
            status: AsyncRequestStatus.Pending
          })
        })
      });
    case createAnalysisStudyActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        createdAnalysisStudyId: action.payload.createdAnalysisStudyId || defaultReducerState.createdAnalysisStudyId
      });
    case loadAnalysisSegmentsActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        segmentsDictAsync: __spreadProps(__spreadValues({}, state.segmentsDictAsync), {
          [segmentDictionaryKey(action.payload.metricSetName, action.payload.metricSetVersionSelected)]: __spreadValues({}, getCompletedAsyncWrapperObj(
            (_b = (_a = action.payload.segmentDataAsync) == null ? void 0 : _a.data) != null ? _b : [],
            ((_d = (_c = action.payload) == null ? void 0 : _c.segmentDataAsync) == null ? void 0 : _d.error) || ""
          ))
        })
      });
    case uploadSupportFilesActionTypes.LOADING:
    case uploadSupportFilesActionTypes.LOADED:
      const supportFileType = action.payload.supportFileType || SupportFileType.ScopeResource;
      const fileStatus = action.payload.fileStatus || {};
      const propertyToUpdate = supportFileType === SupportFileType.ScopeResource ? "scopeResourcesSupportedFiles" : "scopeReferencesSupportedFiles";
      return __spreadProps(__spreadValues({}, state), {
        [propertyToUpdate]: fileStatus
      });
    case sampleForayJobConfigActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        sampleForayJobConfigResultAsync: __spreadProps(__spreadValues({}, state.sampleForayJobConfigResultAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case sampleForayJobConfigActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        sampleForayJobConfigResultAsync: __spreadValues(__spreadValues({}, state.sampleForayJobConfigResultAsync), getCompletedAsyncWrapperObj(
          (_e = action.payload.sampleForayJobConfigResultAsync) == null ? void 0 : _e.data,
          ((_f = action.payload.sampleForayJobConfigResultAsync) == null ? void 0 : _f.error) || ""
        ))
      });
    case validateForayJobConfigActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        forayValidationResponseAsync: __spreadProps(__spreadValues({}, state.forayValidationResponseAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case validateForayJobConfigActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        forayValidationResponseAsync: __spreadValues(__spreadValues({}, state.forayValidationResponseAsync), getCompletedAsyncWrapperObj(
          (_g = action.payload.forayValidationResponseAsync) == null ? void 0 : _g.data,
          ((_h = action.payload.forayValidationResponseAsync) == null ? void 0 : _h.error) || ""
        ))
      });
    default:
      return state;
  }
};
const initialLoadResource = (inputStep, managementGroup, workspaceId, metricSetName) => [
  storeStepIdAndManagementGroup(inputStep.stepId, managementGroup, workspaceId),
  loadAnalysisConfigEpicReducer.actionCreators.load({ workspaceId, managementGroup }),
  loadJobExecMetaEpicReducer.actionCreators.load({ workspaceId, managementGroup }),
  loadAnalysisRequestFormEpicReducer.actionCreators.load(inputStep),
  loadMetricSetsEpicReducer.actionCreators.load({ workspaceId }),
  loadForayConfigMetadataEpicReducer.actionCreators.load(),
  ...metricSetName ? [loadMetricSetVersion({ metricSetName, workspaceId })] : []
];
const postAnalysisTemplateV2LoadResource = (inputPayload, outputPayload) => {
  var _a, _b;
  if (!!inputPayload.setFieldValue) {
    inputPayload.setFieldValue("isMetricServiceTemplate", inputPayload == null ? void 0 : inputPayload.isMetricServiceTemplate);
    inputPayload.setFieldValue("metricSetVersionId", "");
    inputPayload.setFieldValue("metricSetVersionName", "");
    inputPayload.setFieldValue("templateSelectedType", (outputPayload == null ? void 0 : outputPayload.analysisType) || AnalysisTemplateTypeDto.AB);
    inputPayload.setFieldValue("primarySegmentSelected", getPrimarySegmentsV2(outputPayload));
    if (inputPayload.isMetricServiceTemplate) {
      inputPayload.setFieldValue("secondarySegmentsSelected", getSecondarySegmentsV2(outputPayload));
    }
    inputPayload.setFieldValue("selectedVC", (outputPayload == null ? void 0 : outputPayload.virtualCluster) || "");
    if (inputPayload.isMetricServiceTemplate) {
      const forayAppParamters = getForayAppCustomParametersV2(outputPayload);
      inputPayload.setFieldValue("customForayParameters", forayAppParamters);
    }
    setTriggerFilterAndSideStream(
      outputPayload,
      (_a = inputPayload.triggerFilterConfigs) != null ? _a : {},
      (_b = inputPayload.sideStreamTemplateOptions) != null ? _b : [],
      inputPayload.setFieldValue
    );
  }
  return [loadMetricSetVersion({ metricSetName: (outputPayload == null ? void 0 : outputPayload.metricSetName) || "", workspaceId: inputPayload.workspaceId })];
};
const postAnalysisTemplateFromVersionLoadResource = (inputPayload, outputPayload) => {
  var _a, _b;
  if (!!inputPayload.setFieldValue) {
    inputPayload.setFieldValue("isMetricServiceTemplate", true);
    inputPayload.setFieldValue("templateSelectedType", (outputPayload == null ? void 0 : outputPayload.analysisType) || AnalysisTemplateTypeDto.AB);
    inputPayload.setFieldValue("primarySegmentSelected", getPrimarySegmentsV2(outputPayload));
    inputPayload.setFieldValue("secondarySegmentsSelected", getSecondarySegmentsV2(outputPayload));
    inputPayload.setFieldValue("selectedVC", (outputPayload == null ? void 0 : outputPayload.virtualCluster) || "");
    inputPayload.setFieldValue("customForayParameters", getForayAppCustomParametersV2(outputPayload));
    setTriggerFilterAndSideStream(
      outputPayload,
      (_a = inputPayload.triggerFilterConfigs) != null ? _a : {},
      (_b = inputPayload.sideStreamTemplateOptions) != null ? _b : [],
      inputPayload.setFieldValue
    );
  }
  return [];
};
const setTriggerFilterAndSideStream = (selectedTemplate, triggerFilterConfigs, sideStreamTemplateOptions, setFieldValue) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if (!selectedTemplate) {
    return;
  }
  let sideStreamOption = null;
  if (!!selectedTemplate.triggerFilterCondition && !!selectedTemplate.triggerFilterCondition.name) {
    sideStreamOption = parseTriggerFilterCondition(selectedTemplate.triggerFilterCondition);
  } else if (selectedTemplate.triggerFilterConfigs && selectedTemplate.triggerFilterConfigs.length > 0) {
    const sideStreamOptions = selectedTemplate.triggerFilterConfigs.map(
      (triggerFilterConfig) => parseSideStreamInfo(triggerFilterConfig, triggerFilterConfigs)
    );
    sideStreamOption = sideStreamOptions[0];
    const newOptions = ___default.uniqBy(sideStreamOptions, (so) => so.name).filter((so) => !!so.name);
    const allOptions = ___default.uniqBy([...newOptions, ...sideStreamTemplateOptions], (so) => so.name);
    setFieldValue("sideStreamTemplateOptions", allOptions);
  }
  if (!!sideStreamOption) {
    setFieldValue("isEnabledTriggerFilter", true);
    setFieldValue("triggerFilterType", sideStreamOption.type);
    setFieldValue("triggerFilterConditionName", sideStreamOption.name);
    setFieldValue("triggerFilterExpression", sideStreamOption.scopeExpression);
    setFieldValue("selectedSideStreamTemplate", sideStreamOption.name);
    setFieldValue("sideStreamViewLocationInCosmos", (_b = (_a = sideStreamOption.sideStreamInfo) == null ? void 0 : _a.location) != null ? _b : "");
    setFieldValue("sideStreamAvailabilityStream", (_d = (_c = sideStreamOption.sideStreamInfo) == null ? void 0 : _c.availabilityStream) != null ? _d : "");
    setFieldValue(
      "sideStreamJoinColumns",
      (_f = (_e = sideStreamOption.sideStreamInfo) == null ? void 0 : _e.joinColumnPairs) != null ? _f : [
        { metricDataColumn: JoinColumnPairDefaults.MetricDataColumn, sideStreamColumn: JoinColumnPairDefaults.SideStreamColumn }
      ]
    );
    setFieldValue("sideStreamCustomParameters", (_h = (_g = sideStreamOption.sideStreamInfo) == null ? void 0 : _g.customParameters) != null ? _h : []);
  } else {
    setFieldValue("isEnabledTriggerFilter", false);
    setFieldValue("triggerFilterConditionName", "");
    setFieldValue("triggerFilterExpression", "");
    setFieldValue("selectedSideStreamTemplate", "");
    setFieldValue("sideStreamViewLocationInCosmos", "");
    setFieldValue("sideStreamAvailabilityStream", "");
    setFieldValue("sideStreamCustomParameters", []);
    setFieldValue("sideStreamTemplateOptions", []);
    setFieldValue("sideStreamTemplateOptions", []);
  }
};
const dontLoad = (asyncWrapper) => {
  return !!asyncWrapper && (!!asyncWrapper.data || someRequestIsPending(asyncWrapper.status));
};
export {
  afterCreateAnalysisStudy,
  afterCreateAnalysisStudyActionTypes,
  analysisCreateReducer,
  createAnalysisStudy,
  createAnalysisStudyActionTypes,
  createdAnalysisStudy,
  creatingAnalysisStudy,
  analysisCreateReducer as default,
  defaultReducerState,
  loadAnalysisConfigEpicReducer,
  loadAnalysisRequestFormEpicReducer,
  loadAnalysisSegmentsActionTypes,
  loadAnalysisStepPropertiesEpicReducer,
  loadAnalysisTemplateFromVersionEpicReducer,
  loadAnalysisTemplateNamesFromVersionEpicReducer,
  loadAnalysisTemplateV2EpicReducer,
  loadForayConfigMetadataEpicReducer,
  loadJobExecMetaEpicReducer,
  loadMetricSetVersion,
  loadMetricSetVersionEpicReducer,
  loadMetricSetsEpicReducer,
  loadRawStudyEpicReducer,
  loadSampleForayJobConfig,
  loadSegmentData,
  loadedSampleForayJobConfig,
  loadedSegmentData,
  loadingSampleForayJobConfig,
  loadingSegmentData,
  sampleForayJobConfigActionTypes,
  storeStepIdAndManagementGroup,
  storeStepIdAndMgActionType,
  uploadSupportFiles,
  uploadSupportFilesActionTypes,
  uploadedSupportFiles,
  uploadingSupportFiles,
  validateForayConfig,
  validateForayJobConfigActionTypes,
  validatedForayConfig,
  validatingForayConfig
};
//# sourceMappingURL=AnalysisCreateContainer.ducks.js.map
